<ng-template #loadingTemplate>
    <div class="loading-container">
        <div class="logo-wrapper">
            <div class="spinning-border"></div>
            <div class="logo-container">
                <img
                    [src]="logoPath"
                    alt="eFACT Loading"
                    class="efact-logo pulse-animation">
            </div>
        </div>
        <div class="loading-text">{{ loadingText }}</div>
    </div>
</ng-template>
<ng-template #processingTemplate>
    <div class="loading-container">
        <div class="logo-wrapper">
            <div class="spinning-border text-yellow font-bold"></div>
            <div class="logo-container">
                <img
                    [src]="logoPath"
                    alt="eFACT Loading"
                    class="efact-logo pulse-animation">
            </div>
        </div>
        <div class="loading-text">{{ processingText }}</div>
    </div>
</ng-template>
<div [hidden]="!showDelayedLoading || !shouldShow" class="page-overlay" [id]="id" style="z-index: 9999; height: 100vh; width: 100vw;">
    <div class="page-overlay-content" style="z-index: 9999; justify-content: center;">
        <div *ngIf="showDelayedLoading; then loadingTemplate"></div>
    </div>
</div>
<div [hidden]="!processing" class="page-overlay">
    <div class="processing-overlay-content">
        <!-- <i
            class="pi pi-exclamation-triangle mr-2"
            style="font-size: 2rem;"
        ></i> -->
        <div *ngIf="processing; then processingTemplate" class="font-bold"></div>
    </div>
</div>
